import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const REGION_ID = "qr-reader-region";

export default function QrScanner({ open, onOpenChange, onScan, title = "Scan order QR" }) {
  const scannerRef = useRef(null);
  const onScanRef = useRef(onScan);
  const [error, setError] = useState("");

  useEffect(() => { onScanRef.current = onScan; }, [onScan]);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setError("");
    const start = async () => {
      try {
        const scanner = new Html5Qrcode(REGION_ID, { verbose: false });
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 240, height: 240 } },
          (decodedText) => {
            if (cancelled) return;
            onScanRef.current && onScanRef.current(decodedText);
          },
          () => {}
        );
        // Dialog may have closed while start() was resolving — shut the camera back down.
        if (cancelled) {
          scanner.stop().then(() => scanner.clear()).catch(() => {});
        }
      } catch (e) {
        if (!cancelled) setError("Couldn't open the camera. Allow camera access or type the code instead.");
      }
    };
    const t = setTimeout(start, 200);
    return () => {
      cancelled = true;
      clearTimeout(t);
      const s = scannerRef.current;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="qr-scanner-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>Point your camera at the order&rsquo;s QR label.</DialogDescription>
        </DialogHeader>
        <div id={REGION_ID} className="overflow-hidden rounded-xl bg-black" />
        {error && <p className="text-sm text-red-500" data-testid="qr-scanner-error">{error}</p>}
      </DialogContent>
    </Dialog>
  );
}
